import React from 'react';
import './App.css';

function PrivacyPolicy() {
  return (
    <div className="App">
      <div className="privacy-container">
        <h1>개인정보 처리방침</h1>
        <div className="privacy-content">
          <p>마지막 수정일: 2025년 5월 13일</p>
          
          <h2>1. 수집하는 개인정보</h2>
          <p>현재 초성게임은 사용자의 개인정보를 수집하지 않습니다.</p>
          
          <h2>2. 개인정보의 이용</h2>
          <p>초성게임은 사용자의 개인정보를 수집하지 않으므로, 이용 목적이 없습니다.</p>
          
          <h2>3. 개인정보의 보호</h2>
          <p>초성게임은 사용자의 개인정보를 수집하지 않으므로, 보호 조치가 필요하지 않습니다.</p>
          
          <h2>4. 문의</h2>
          <p>개인정보 처리방침에 대한 문의사항이 있으시면 아래로 연락해 주시기 바랍니다.</p>
          <p>이메일: dev@devbrix.kr</p>
        </div>
        <a href="/" className="back-link">← 메인으로 돌아가기</a>
      </div>
    </div>
  );
}

export default PrivacyPolicy; 